<script lang="ts">
  import Timeline from './Timeline.svelte';
  let { personId, verticalId, companyId, contactOwnerUserId: _owner }: { personId: number; verticalId: number; companyId: number | null; contactOwnerUserId?: number | null } = $props();
</script>
<Timeline {personId} {verticalId} {companyId} />
